import { render } from "./ReviewCancelBanner.vue?vue&type=template&id=1835bd21"
import script from "./ReviewCancelBanner.vue?vue&type=script&lang=js"
export * from "./ReviewCancelBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__